import React from "react";

const SEOSettingsList = ({
  seoSettings,
  loading,
  onEdit,
  onDelete,
  onView,
  onShowModal,
}) => {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Loading SEO settings...</p>
      </div>
    );
  }

  if (seoSettings.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-icon">📄</div>
        <h3>No SEO Settings Found</h3>
        <p>Create your first SEO setting to get started.</p>
      </div>
    );
  }

  const handleView = (setting) => {
    onView(setting);
    onShowModal(true);
  };

  return (
    <div className="seo-settings-list">
      <div className="table-responsive">
        <table className="table table-hover">
          <thead className="table-dark">
            <tr>
              <th>Page Path</th>
              <th>Title</th>
              <th>Status</th>
              <th>Last Updated</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {seoSettings.map((setting) => (
              <tr
                key={setting.id}
                className={!setting.isActive ? "table-secondary" : ""}
              >
                <td>
                  <div className="page-path">
                    <strong>{setting.pagePath}</strong>
                    {setting.canonicalUrl && (
                      <small className="text-muted d-block">
                        Canonical: {setting.canonicalUrl}
                      </small>
                    )}
                  </div>
                </td>
                <td>
                  <div className="title-info">
                    <div className="title-text" title={setting.title}>
                      {setting.title}
                    </div>
                    {setting.description && (
                      <small className="text-muted d-block description-preview">
                        {setting.description.length > 60
                          ? `${setting.description.substring(0, 60)}...`
                          : setting.description}
                      </small>
                    )}
                  </div>
                </td>
                <td>
                  <span
                    className={`badge ${
                      setting.isActive ? "bg-success" : "bg-secondary"
                    }`}
                  >
                    {setting.isActive ? "Active" : "Inactive"}
                  </span>
                </td>
                <td>
                  {setting.updatedAt ? (
                    <span
                      title={new Date(
                        setting.updatedAt.toDate()
                      ).toLocaleString()}
                    >
                      {new Date(
                        setting.updatedAt.toDate()
                      ).toLocaleDateString()}
                    </span>
                  ) : (
                    <span className="text-muted">N/A</span>
                  )}
                </td>
                <td>
                  <div className="action-buttons">
                    <button
                      className="btn btn-sm btn-outline-info"
                      onClick={() => handleView(setting)}
                      title="View Details"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => onEdit(setting)}
                      title="Edit"
                    >
                      <i className="fas fa-edit"></i>
                    </button>
                    <button
                      className="btn btn-sm btn-outline-danger"
                      onClick={() => onDelete(setting.id)}
                      title="Delete"
                    >
                      <i className="fas fa-trash"></i>
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="list-footer">
        <div className="results-info">
          Showing {seoSettings.length} SEO setting
          {seoSettings.length !== 1 ? "s" : ""}
        </div>
      </div>
    </div>
  );
};

export default SEOSettingsList;
